import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/home/index.vue')
  },
  {
    path: '/test/a',
    name: 'A',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/test/A.vue')
  },
  {
    path: '/test/b',
    name: 'B',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/test/B.vue')
  },
  {
    path: '/test/c',
    name: 'C',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/test/C.vue')
  },
  {
    path: '/test/d',
    name: 'D',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/test/D.vue')
  },
  {
    path: '/login',
    name: 'D',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/login/login.vue')
  },
  {
    path: '/register',
    name: 'D',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/login/register.vue')
  },
  {
    path: '/bottom/aboutus',
    name: 'aboutus',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/aboutus.vue')
  },
  {
    path: '/bottom/contactUs',
    name: 'contactUs',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/contactUs.vue')
  },
  {
    path: '/bottom/help',
    name: 'help',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/help.vue')
  },
  {
    path: '/bottom/supervision',
    name: 'supervision',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/supervision.vue')
  },{
    path: '/bottom/publishReview',
    name: 'publishReview',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/publishReview.vue')
  },{
    path: '/bottom/informationProcessing',
    name: 'informationProcessing',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/informationProcessing.vue')
  },{
    path: '/bottom/websiteAnnouncement',
    name: 'websiteAnnouncement',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/websiteAnnouncement.vue')
  },{
    path: '/bottom/businessLicense',
    name: 'businessLicense',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/bottom/businessLicense.vue')
  },
  {
    path: '/test/detail',
    name: 'detail',
    // component: HomeView
    component: () => import(/* webpackChunkName: "about" */ '../views/test/detail.vue')
  },
]

const router = new VueRouter({
  routes
})

export default router
